import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';

const isProduction = process.env.NODE_ENV === 'production';

export function ErrorBoundary({ children, fallback }) {
  if (isProduction) {
    return (
      <ReactErrorBoundary
        fallback={fallback}
        onError={(error: Error, info: { componentStack: string }) => {
          console.log('error');
          console.log(error);

          console.log('info');
          console.log(info);
        }}
      >
        {children}
      </ReactErrorBoundary>
    );
  }

  return <>{children}</>;
}
